import { Link, useLocation, useParams } from 'react-router-dom';
import ShareLike from '../ShareLike/ShareLike';
import { ArrowLeft } from '../../assets/icons';
import './SMNav.scss';

const SMNav = () => {
  const { propertyId } = useParams();
  const location = useLocation();
  return (
    <div className='d-flex justify-content-space-between align-items-center py-20 bg-white px-20'>
      {location.hash.length && location.hash === '#portfolio-assets' ? (
        <div className='smnav__back'>
          <Link className='text-almost-black' to={`/portfolio/assets/${propertyId}`} replace={true}>
            <ArrowLeft verticalAlign='-7px' marginRight='12px' />
          </Link>
          <span className='fw-600'>Back to asset details info</span>
        </div>
      ) : (
        <div className='smnav__back'>
          <Link className='text-almost-black' to={`/property/secondary/${propertyId}`} replace={true}>
            <ArrowLeft verticalAlign='-7px' marginRight='12px' />
          </Link>
          <span className='fw-600'>Back to property info</span>
        </div>
      )}
      <ShareLike />
    </div>
  );
};

export default SMNav;
